"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortDatesStrings = exports.getActionButtonsSorter = exports.getSortOrder = exports.numberOfConditionIssuesSorter = exports.enabledFor4ResidentsSorter = exports.estimatedDurationSorter = exports.prioritySorter = exports.getNumberPropertySorter = exports.numberSorter = exports.timestampSorter = exports.getDatePropertySorter = exports.dateSorter = exports.statusSorter = exports.categoryNameSorter = exports.serviceTaskTypeNameSorter = exports.typeNameSorter = exports.labelSorter = exports.timeZoneSorter = exports.nameSorter = exports.getStringPropertySorter = exports.stringSorter = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
function stringSorter(a, b) {
    var _a, _b;
    return ((_a = a === null || a === void 0 ? void 0 : a.trim()) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b === null || b === void 0 ? void 0 : b.trim()) !== null && _b !== void 0 ? _b : '');
}
exports.stringSorter = stringSorter;
function getStringPropertySorter(getProperty) {
    return (a, b) => stringSorter(getProperty(a), getProperty(b));
}
exports.getStringPropertySorter = getStringPropertySorter;
function nameSorter(a, b) {
    return stringSorter(a === null || a === void 0 ? void 0 : a.name, b === null || b === void 0 ? void 0 : b.name);
}
exports.nameSorter = nameSorter;
function timeZoneSorter(a, b) {
    return stringSorter(a === null || a === void 0 ? void 0 : a.name, b === null || b === void 0 ? void 0 : b.name);
}
exports.timeZoneSorter = timeZoneSorter;
function labelSorter(a, b) {
    return stringSorter(a === null || a === void 0 ? void 0 : a.label, b === null || b === void 0 ? void 0 : b.label);
}
exports.labelSorter = labelSorter;
function typeNameSorter(a, b) {
    return stringSorter(a === null || a === void 0 ? void 0 : a.typeName, b === null || b === void 0 ? void 0 : b.typeName);
}
exports.typeNameSorter = typeNameSorter;
function serviceTaskTypeNameSorter(a, b) {
    return stringSorter(a === null || a === void 0 ? void 0 : a.serviceTaskTypeName, b === null || b === void 0 ? void 0 : b.serviceTaskTypeName);
}
exports.serviceTaskTypeNameSorter = serviceTaskTypeNameSorter;
function categoryNameSorter(a, b) {
    return stringSorter(a === null || a === void 0 ? void 0 : a.categoryName, b === null || b === void 0 ? void 0 : b.categoryName);
}
exports.categoryNameSorter = categoryNameSorter;
function statusSorter(a, b) {
    return stringSorter(a === null || a === void 0 ? void 0 : a.statusName, b === null || b === void 0 ? void 0 : b.statusName) || stringSorter(a === null || a === void 0 ? void 0 : a.subStatusName, b === null || b === void 0 ? void 0 : b.subStatusName);
}
exports.statusSorter = statusSorter;
function dateSorter(a, b) {
    if (!a)
        return -1;
    if (!b)
        return 1;
    const d1 = (0, dayjs_1.default)(a);
    const d2 = (0, dayjs_1.default)(b);
    if (d1.isSame(d2))
        return 0;
    return d1.isAfter(d2) ? 1 : -1;
}
exports.dateSorter = dateSorter;
function getDatePropertySorter(getProperty) {
    return (a, b) => dateSorter(getProperty(a), getProperty(b));
}
exports.getDatePropertySorter = getDatePropertySorter;
/* eslint-disable no-underscore-dangle */
function timestampSorter(a, b) {
    if (a._timestamp === b._timestamp)
        return 0;
    return a._timestamp > b._timestamp ? 1 : -1;
}
exports.timestampSorter = timestampSorter;
function numberSorter(a, b) {
    if (a === b) {
        return 0;
    }
    return (a || 0) < (b || 0) ? -1 : 1;
}
exports.numberSorter = numberSorter;
function getNumberPropertySorter(getProperty) {
    return (a, b) => numberSorter(getProperty(a), getProperty(b));
}
exports.getNumberPropertySorter = getNumberPropertySorter;
function prioritySorter(a, b) {
    return numberSorter(a.priorityLevelOfImportance, b.priorityLevelOfImportance);
}
exports.prioritySorter = prioritySorter;
function estimatedDurationSorter(a, b) {
    return numberSorter(a.estimatedDuration, b.estimatedDuration);
}
exports.estimatedDurationSorter = estimatedDurationSorter;
function enabledFor4ResidentsSorter(a, b) {
    return numberSorter(a.enabledFor4Residents ? 1 : 0, b.enabledFor4Residents ? 1 : 0);
}
exports.enabledFor4ResidentsSorter = enabledFor4ResidentsSorter;
function numberOfConditionIssuesSorter(a, b) {
    return numberSorter(a.conditionIssueInstances.length, b.conditionIssueInstances.length);
}
exports.numberOfConditionIssuesSorter = numberOfConditionIssuesSorter;
function getSortOrder(columnName, paging) {
    if (columnName !== paging.sortBy)
        return undefined;
    return paging.sortAscending ? 'ascend' : 'descend';
}
exports.getSortOrder = getSortOrder;
function getActionButtonsSorter(a, b) {
    const getButtonType = (x) => { var _a; return (_a = x.attributes) === null || _a === void 0 ? void 0 : _a.buttonType; };
    const [typeA, typeB] = [getButtonType(a), getButtonType(b)];
    if (typeA === typeB)
        return 0;
    if (typeA === 'dashed' || typeB === 'primary')
        return -1;
    if (typeB === 'primary' || typeA === 'dashed')
        return 1;
    return 0;
}
exports.getActionButtonsSorter = getActionButtonsSorter;
function sortDatesStrings(dates) {
    return dates.sort((a, b) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateA.getTime() - dateB.getTime();
    });
}
exports.sortDatesStrings = sortDatesStrings;
